var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-passage"},[(_vm.hasError)?_c('IbxItemError'):_c('pie-player',{ref:"player",on:{"load-complete":_vm.onLoaded,"player-error":_vm.onError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }